<template>
  <div class="drawer-detail">
    <div v-for="field in ['公司备注']" :key="field" class="field-type">
      <span class="label">
        {{translateTag[field]||field}}:
        <el-tooltip :disabled="!showLogs||showLogs.length===0" :visible-arrow="false" popper-class="alpha-color-ccc" effect="light" placement="left">
          <div slot="content" style="max-height:300px;width:300px;overflow:auto;">
            <div v-for="item in showLogs" :key="item.updatedAt" class="edit-dialog-single-p" style="flex-wrap:wrap">
              <b style="color:#BCBCBC">{{ item.updatedAt | formatdate }} -- {{ item.account }}</b>
              <span style="display:block;width:100%;margin-top:10px;margin-bottom: 10px;white-space:pre-wrap;color:#333;"><i class="el-icon-info"></i> {{ item.content }}</span>
            </div>
          </div>
          <span :class="!showLogs||showLogs.length===0?'shallow-gray-text':'link-text'"><i class="el-icon-view mr10"></i>阿尔法认知备注</span>
        </el-tooltip>
      </span>
      <div :class="[company[field]?'':'gray-text','value company-pre']">
        <p v-if="company[field]">{{company[field]}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit(field)"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  filters: {
    formatdate: function (date) {
      const createdDate = new Date(date)
      if (!date) {
        return
      }
      return `${createdDate.getFullYear()}-${
        createdDate.getMonth() + 1
      }-${createdDate.getDate()}  ${createdDate.getHours()}:${
        createdDate.getMinutes() < 10 ? `0${createdDate.getMinutes()}` : createdDate.getMinutes()
      }`
    },
  },
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['公司备注'],
      translateTag: {
        公司备注: '阿尔法认知',
      },
    }
  },
  computed: {
    showLogs() {
      const logs = window._.cloneDeep(this.company.阿尔法认知 || [])
      logs.sort((a, b) => b.updatedAt - a.updatedAt)
      return logs
    },
  },
  methods: {
    quickEdit(field){
      const { translateTag, company } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style>
.alpha-color-ccc{
  border-color:#CCCCCC!important;
  box-shadow: 0 0 5px 0px #d0d0d0;
}
</style>
<style scoped>
.flex {
  display: flex;
}
.cognize-box{
  display: flex;
  flex-wrap:wrap;
}
.cognize-box span{
  display: inline-block;
  min-width: 50%;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
